import { render, staticRenderFns } from "./article_privacy.vue?vue&type=template&id=0ec0300c&scoped=true&"
import script from "./article_privacy.vue?vue&type=script&lang=js&"
export * from "./article_privacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec0300c",
  null
  
)

export default component.exports